import React, { useEffect, useState } from "react";
import { withTranslation } from "react-i18next";
import { AllPrimaryDeploymentReport } from "../../../Apis/TransferStationReport/primaryDeploymentTransactionReportApi";
import TableComponent from "../../../Common/TableComponent/tableComponent";
import Loader from "../../../Common/Loader/loader";
import * as XLSX from "xlsx";
import ExcelJS from "exceljs";
import isGHMC, { getCurrentDateTime1 } from "../../../Common/helper/helpar";
import { GetZone } from "../../../Apis/organizationApi";

const PrimaryDeploymentTransactionReport = ({ t }) => {
  const headers = [
    "vehicleUid",
    "vehicleNumber",
    "zone",
    "circle",
    "ward",
    "vehicleType",
    "ownerType",
    "pdincharge",
    "driverName",
    "deploymentDate",
    "latitude",
    "longitude",
    "address",
    "image",
  ];

  const [getAllTripsTonnage, setAllTripsTonnage] = useState([]);
  const [startDate, setStartDate] = useState(getStartOfCurrentDate());
  const [endDate, setEndDate] = useState(getCurrentDateTime());
  const [isLoading, setIsLoading] = useState(false);
  const [vehicleNumber, setVehicleNumber] = useState("");
  const [allZones, setAllZones] = useState("");
  const [zoneId, setZoneId] = useState("");
  const isProd = isGHMC();

  const fetchAllZoneData = async () => {
    try {
      const zonesData = await GetZone();
      setAllZones(zonesData);
    } catch (error) {
      console.error("Error fetching initial data:", error);
    }
  };

  useEffect(() => {
    fetchAllZoneData();
    fetchTripsTonnageData(startDate, endDate, vehicleNumber, zoneId);
  }, []);

  const fetchTripsTonnageData = async (startDate, endDate, vehicleNumber, zoneId) => {
    try {
      setIsLoading(true);
      const response = await AllPrimaryDeploymentReport(startDate, endDate, vehicleNumber, zoneId);
      const formattedData = response.data.map((item) => ({
        ...item,
        vehicleUid: item.vehicleUuid || "N/A",
        image: item.vehicleImageUrl || "N/A",
        pdincharge: item.primaryDeploymentInchargeName || "N/A",
        latitude: item.scannedLatitude || "N/A",
        longitude: item.scannedLongitude || "N/A",
        address: item.address || "N/A",
        zone: item.zoneName || "N/A",
        circle: item.circleName || "N/A",
        ward: item.wardName || "N/A",
        vehicleType: item.vehicleTypeName || "N/A",
        ownerType: item.ownerTypeName || "N/A",
      }));
      setAllTripsTonnage(formattedData);
      setIsLoading(false);
    } catch (error) {
      console.log(error);
      setIsLoading(false);
    }
  };

  const handleFormSubmit = (e) => {
    e.preventDefault();
    fetchTripsTonnageData(startDate, endDate, vehicleNumber, zoneId);
  };

  // Function to format dates for display
  const formatDateForDisplay = (dateString) => {
    const date = new Date(dateString);
    const options = { day: '2-digit', month: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit' };
    return date.toLocaleString('en-GB', options).replace(',', '');
  };

  const options = { day: 'numeric', month: 'numeric', year: 'numeric' };
  const generationTime = ` ${new Date().toLocaleString('en-GB', options).replace(/\//g, '/')}`;
  const downloadAsExcel = async () => {
    const currentDate = new Date();
    const formattedDate = `${currentDate.getDate()}-${
      currentDate.getMonth() + 1
    }-${currentDate.getFullYear()}`;
    const formattedTime = `${currentDate.getHours()}:${currentDate.getMinutes()}:${currentDate.getSeconds()}`;
    const cumulativeHeadingReport = ` Primary Deployment Transaction Report as on (${formatDateForDisplay(startDate)} to ${formatDateForDisplay(endDate)}) -  (at ${getCurrentDateTime1()})`;
    const downloadDateTime = `Report on: ${generationTime}, ${formattedTime}`;
    const dateRange = `Date Range: ${formatDateForDisplay(startDate)} to ${formatDateForDisplay(endDate)} `;

    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet("Zones");
    const boldFont = { bold: true };

    // Add Report Generation Date
    worksheet.addRow(["", "", downloadDateTime, ""]);
    worksheet.mergeCells(1, 2, 1, 11);
    worksheet.getCell(1, 2).value = downloadDateTime;
    worksheet.getCell(1, 2).font = boldFont;
    worksheet.getCell(1, 2).alignment = { horizontal: "center" };

    for (let col = 2; col <= 11; col++) {
      worksheet.getCell(1, col).font = boldFont;
      worksheet.getCell(1, col).alignment = { horizontal: "center" };
    }

    // // Add Date Range
    // worksheet.addRow(["", "", dateRange, ""]);
    // worksheet.mergeCells(2, 2, 2, 11);
    // worksheet.getCell(2, 2).value = dateRange;
    // worksheet.getCell(2, 2).font = boldFont;
    // worksheet.getCell(2, 2).alignment = { horizontal: "center" };

    for (let col = 2; col <= 11; col++) {
      worksheet.getCell(2, col).font = boldFont;
      worksheet.getCell(2, col).alignment = { horizontal: "center" };
    }

    // Add Report Title
    worksheet.addRow(["", "", cumulativeHeadingReport, ""]);
    worksheet.mergeCells(3, 2, 3, 11);
    worksheet.getCell(3, 2).value = cumulativeHeadingReport;
    worksheet.getCell(3, 2).font = boldFont;
    worksheet.getCell(3, 2).alignment = { horizontal: "center" };

    for (let col = 2; col <= 11; col++) {
      worksheet.getCell(3, col).font = boldFont;
      worksheet.getCell(3, col).alignment = { horizontal: "center" };
    }

    // Add empty row for spacing
    worksheet.addRow([""]);

    // Add table header row with bold font
    const tableHeaderRow = worksheet.addRow([
      "S.No",
      "Vehicle UID",
      "Vehicle Number",
      "Zone",
      "Circle",
      "Ward",
      "Vehicle Type",
      "Owner Type",
      "PD Incharge",
      "Driver Name",
      "Deployment Date",
      "Latitude",
      "Longitude",
      "Address",
    ]);

    tableHeaderRow.eachCell({ includeEmpty: true }, (cell, colNumber) => {
      cell.font = boldFont;
      cell.alignment = { horizontal: "left" };
      if (colNumber >= 1 && colNumber <= 14) {
        cell.fill = {
          type: "pattern",
          pattern: "solid",
          fgColor: { argb: "F6B1B1" },
        };
      }
    });

    // Add data rows
    getAllTripsTonnage.forEach((item, index) => {
      worksheet.addRow([
        index + 1,
        item.vehicleUuid ?? "N/A",
        item.vehicleNumber ?? "N/A",
        item.zone ?? "N/A",
        item.circle ?? "N/A",
        item.ward ?? "N/A",
        item.vehicleTypeName ?? "N/A",
        item.ownerTypeName ?? "N/A",
        item.primaryDeploymentInchargeName ?? "N/A",
        item.driverName ?? "N/A",
        item.deploymentDate ?? "N/A",
        item.latitude ?? "N/A",
        item.longitude ?? "N/A",
        item.address ?? "N/A",
      ]).eachCell({ includeEmpty: true }, (cell, colNumber) => {
        if (colNumber >= 1 && colNumber <= 14) {
          cell.alignment = { horizontal: "left", vertical: "middle", wrapText: true };
        } else {
          cell.alignment = { horizontal: "center", vertical: "middle", wrapText: true };
        }
      });
    });

    // Set column widths dynamically based on content
    worksheet.columns = [
      { width: 5 },
      { width: 20 },
      { width: 20 },
      { width: 20 },
      { width: 20 },
      { width: 20 },
      { width: 20 },
      { width: 20 },
      { width: 20 },
      { width: 20 },
      { width: 20 },
      { width: 20 },
      { width: 20 },
      { width: 100 },
    ];

    // Save the workbook to a file
    const buffer = await workbook.xlsx.writeBuffer();
    const blob = new Blob([buffer], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = "primaryDeploymentTransactionReports.xlsx";
    a.click();
    URL.revokeObjectURL(url);
  };

  return (
    <>
      {isLoading ? (
        <Loader />
      ) : (
        <div style={{ width: "100%" }}>
          <div className="content">
            <div className="page-content">
              <h4 className="text-start mb-3">
                Primary Deployment Transaction Report as on ({formatDateForDisplay(startDate)} to {formatDateForDisplay(endDate)}) -  (at {getCurrentDateTime1()})
              </h4>
              <div className="card">
                <div className="card-body p-3">
                  <form onSubmit={handleFormSubmit}>
                    <div className="row align-items-end">
                      <div className="col-md-10">
                        <div className="row" style={{ textAlign: "left" }}>
                          <div className="col-md-3">
                            <label>From Date & Time:</label>
                            <input
                              type="datetime-local"
                              name="FromDate"
                              style={inputStyle}
                              className="form-control"
                              value={startDate}
                              max={endDate ? endDate : getCurrentDateTime()}
                              onChange={(e) => setStartDate(e.target.value)}
                            />
                          </div>
                          <div className="col-md-3">
                            <label>To Date & Time:</label>
                            <input
                              type="datetime-local"
                              name="ToDate"
                              style={inputStyle}
                              value={endDate}
                              className="form-control"
                              min={startDate}
                              max={getCurrentDateTime()}
                              onChange={(e) => setEndDate(e.target.value)}
                            />
                          </div>
                          <div className="col-md-3">
                            <label>Vehicle Number</label>
                            <input
                              type="text"
                              name="vehicleTypeCode"
                              style={inputStyle}
                              placeholder="Vehicle Number"
                              className="form-control"
                              value={vehicleNumber}
                              onChange={(e) => {
                                setVehicleNumber(e.target.value.replace(/\s+/g, ""));
                              }}
                            />
                          </div>
                          <div className="col-md-3">
                            <label htmlFor="StartDate">Zone:</label>
                            <select
                              name="ZoneId"
                              className="form-select"
                              value={zoneId}
                              onChange={(e) => setZoneId(e.target.value)}
                            >
                              <option value="">Select</option>
                              {allZones &&
                                allZones
                                  ?.filter((zone) => zone.isActive)
                                  .map((zone) => (
                                    <option key={zone.zoneId} value={zone.zoneId}>
                                      {zone.zoneName}
                                    </option>
                                  ))}
                            </select>
                          </div>
                        </div>
                      </div>
                      <div className="col-md-2">
                        <div className="d-flex justify-content-between">
                          <button
                            type="submit"
                            className={`btn mt-4 ${isProd ? "search-ghmc" : "search-swm"}`}
                          >
                            Search
                          </button>
                          <button
                            className="btn btn-excel ms-auto mt-4"
                            onClick={downloadAsExcel}
                          >
                            <i className="fa-solid fa-file-excel me-1 icon-container"></i> Excel
                          </button>
                        </div>
                      </div>
                    </div>
                  </form>

                  <div className="mt-3">
                    <TableComponent
                      DataFetchURL={getAllTripsTonnage}
                      headers={headers}
                      imgField="image"
                      filterFunction={(data) =>
                        data.filter((item) => item.status === 1 || item.status === 2)
                      }
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default withTranslation()(PrimaryDeploymentTransactionReport);

// Styles for input and button
const inputStyle = {
  border: "1px solid #E2E2E2",
  padding: "15px",
};

const buttonStyle = {
  border: "1px solid #E2E2E2",
  marginTop: "29px",
  borderRadius: "5px",
  color: "#fff",
};

// Function to get the start of the current date (00:00 AM)
const getStartOfCurrentDate = () => {
  const now = new Date();
  const year = now.getFullYear();
  const month = String(now.getMonth() + 1).padStart(2, "0");
  const day = String(now.getDate()).padStart(2, "0");
  return `${year}-${month}-${day}T00:00`;
};

// Function to get current date and time in the required format
const getCurrentDateTime = () => {
  const now = new Date();
  const year = now.getFullYear();
  const month = String(now.getMonth() + 1).padStart(2, "0");
  const day = String(now.getDate()).padStart(2, "0");
  const hour = String(now.getHours()).padStart(2, "0");
  const minute = String(now.getMinutes()).padStart(2, "0");
  return `${year}-${month}-${day}T${hour}:${minute}`;
};